import React, { useEffect, useState } from "react";
import { Typography, Box, useTheme, InputBase, IconButton, Paper, MenuList, MenuItem, Select, ClickAwayListener, Autocomplete, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import CheckIcon from "@mui/icons-material/Check";
import { ReactComponent as Search } from "../../assets/images/searchIcon.svg";
import { ReactComponent as Edit } from "../../assets/images/editWhite.svg";
import SortBy from "../SortBy";
import styles from "./styles";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";
import { refreshDateFormat } from "../../utils/dateFormatStore";

const SubHeader = ({ permission, btn2, title, BtnText, BtnText2, onClick, onClick2, isShowFilter, fromDate, setFromDate, dateRange,
  filter, onchange, search, sortBy, edit, handleSort, toDate, setToDate, btn, onCompanyChange, disabled, filterData, setGetFilterValue,
  getFilterVaue, infoTexts = [], sortOptions, filterContent }) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [company, setCompany] = useState(localStorage.getItem("selectedCompany") || "");
  const [companyList, setCompanyList] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(getFilterVaue || null);
  const permissions = localStorage.getItem("permission");
  const id = localStorage.getItem("companyId");
  const theme = useTheme();
  const admin = localStorage.getItem("role");
  const { showAlert } = useAlert();

  useEffect(() => {
    if (admin === "Admin" || permissions?.account?.isEdit) {
      getCompanyList();
    }

    const savedCompany = localStorage.getItem("selectedCompany");
    if (savedCompany) {
      setCompany(savedCompany);
    }
  }, []);

  useEffect(() => {
    checkCompany();
  }, [id, companyList]);

  useEffect(() => {
    if (getFilterVaue !== undefined) {
      setSelectedFilter(getFilterVaue);
    }
  }, [getFilterVaue]);

  const checkCompany = () => {
    const savedCompany = localStorage.getItem("selectedCompany");
    if (savedCompany) {
      setCompany(savedCompany);
    } else if (companyList?.length > 0) {
      const value = companyList?.filter(item => item?._id === id);
      setCompany(value[0]?.companyName || "");
    }
  };

  const getCompanyList = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCompantList();
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        setCompanyList(result?.data);
        checkCompany()
      } else {
        showAlert(result?.message, "error");
      }
    } catch (error) {
      showAlert(error, "error");
    }
  };

  const handleCompanyDetails = async (id, companyName) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleCompanyDetails(id);
      if (result?.success) {
        localStorage.setItem("accessToken", result?.data?.token);
        refreshDateFormat();
        localStorage.setItem("email", result?.data?.company?.email);
        localStorage.setItem("id", result?.data?.company?._id)
        localStorage.setItem("employeeId", result?.data?.role === "employee" ? result?.data?.userId : result?.data?.company?.admin);
        LoaderHelper.loaderStatus(false);
        localStorage.setItem("selectedCompany", companyName);
        setCompany(companyName);
        LoaderHelper.loaderStatus(false);
        onCompanyChange();
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleFilter = (value, label) => {
    setGetFilterValue(value)
  };

  return (
    <Box mt="15px" mb="15px" display="flex" flexDirection={{ xs: "column", md: "row" }} justifyContent="space-between" px="20px" pt="20px">
      <Box display="flex" flexDirection="row" alignItems={{ xs: "start", md: "center" }} justifyContent="space-between" flexWrap={{ xs: "wrap" }} gap={{ xs: "10px" }}>
        <Box>
          <Box sx={styles.infoRow}>
            <Typography
              color={theme.palette.black.main}
              fontWeight="bold"
              sx={styles.headingText}
            >
              {title}
            </Typography>
            {infoTexts?.length > 0 && (
              <Box sx={styles.inlineInfoContainer}>
                {infoTexts.map((info, index) => (
                  <Typography
                    key={index}
                    component="span"
                    sx={styles.inlineInfoText}
                  >
                    {info}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        </Box>
        <Box gap={{ xs: "10px" }} display={"flex"}>
          {permission ? (
            <Button variant="contained" onClick={onClick} color="success" sx={{ borderRadius: 50, textTransform: "none", backgroundColor: "#28AA4A", ml: { xs: 0, md: "10px" } }}>
              {edit && <Edit />}
              <Typography sx={{ ml: 1, fontSize: "12px" }}> {BtnText}</Typography>
            </Button>
          ) : (btn && BtnText) ? (
            <Button variant="contained" onClick={onClick} disabled={disabled} color="success" sx={{ borderRadius: 50, textTransform: "none", backgroundColor: "#28AA4A", fontSize: "12px", px: 3, ml: { xs: 0, md: "10px" } }}>
              {BtnText}
            </Button>

          ) : null}
          {btn2 && BtnText2 ? (

            <Button variant="contained" onClick={onClick2} color="success" sx={{ borderRadius: 50, textTransform: "none", backgroundColor: "#28AA4A", fontSize: "12px", px: 3, ml: { xs: 0, md: "10px" } }}>
              {BtnText2}
            </Button>
          ) : null}
        </Box>
      </Box>
      {dateRange && (
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker", "DatePicker"]} sx={styles.calender}>
              <DatePicker label="From" value={fromDate} onChange={(newValue) => { setFromDate(newValue) }} sx={styles.calenderInput} />
              <DatePicker
                label="To"
                value={toDate}
                minDate={fromDate}
                sx={styles.calenderInput}
                onChange={(newValue) => { setToDate(newValue); }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Box>
      )}

      <Box display="flex" flexDirection={{ xs: "row", md: "row" }} justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "center", md: "end" }} mt={{ xs: "20px", md: 0 }} flexWrap={{ xs: "wrap", md: "nowrap" }}>
        {search && (
          <Box
            display="flex"
            backgroundColor={theme.palette.lightGray.main}
            borderRadius="30px"
            width="100%"
            marginRight={{ xs: 0, md: "10px" }}
            justifyContent="center" // Center align on smaller screens
            marginBottom={{ xs: "20px", md: 0 }} // Add margin bottom on smaller screens
          >
            <IconButton type="button" sx={{ p: 1 }}>
              <Search />
            </IconButton>
            <InputBase sx={{ flex: 1, fontSize: "12px" }} placeholder="Search" onChange={(e) => onchange(e.target.value)} />
          </Box>
        )}
        <Box sx={{ display: "flex", flexDirection: { xs: "row", md: "row" } }}>
          {sortBy && <SortBy handleSort={handleSort} options={sortOptions} />}
          <Box sx={styles.filterContainer}>
            {isShowFilter && (
              <Box
                sx={styles.filterButton} // Add margin bottom on smaller screens
                onClick={() => { setOpenFilter(!openFilter) }}
              >
                <IconButton type="button">
                  <FilterListIcon sx={styles.icon} />
                </IconButton>
                <Typography sx={{ fontSize: "12px", cursor: 'pointer' }}>Filter</Typography>
              </Box>
            )}
            {openFilter && (
              <ClickAwayListener onClickAway={() => setOpenFilter(false)}>
                <Paper sx={styles.filterItem}>
                  <MenuList>
                    {filterData && filterData.length > 0 ? (
                      filterData.map((item, index) => (
                        <MenuItem
                          key={index}
                          sx={styles.dropdownMenu}
                          onClick={() => {
                            setSelectedFilter(item.value);
                            handleFilter(item.value, item.label);
                            setOpenFilter(false);
                          }}
                        >
                          {item.label}
                          {selectedFilter === item.value && <CheckIcon fontSize="small" sx={{ ml: 1 }} />}
                        </MenuItem>
                      ))
                    ) : (
                      <>
                        <MenuItem sx={styles.dropdownMenu} onClick={() => { filter("", ""); setOpenFilter(false) }}>
                          All
                        </MenuItem>
                        <MenuItem sx={styles.dropdownMenu} onClick={() => { filter("", "Today"); setOpenFilter(false) }}>
                          Today Absent
                        </MenuItem>
                        <MenuItem sx={styles.dropdownMenu} onClick={() => { filter("", "Week"); setOpenFilter(false) }}>
                          Weekly Absent
                        </MenuItem>
                      </>
                    )}
                  </MenuList>
                  {typeof filterContent === "function" ? filterContent(() => setOpenFilter(false)) : filterContent}
                </Paper>
              </ClickAwayListener>
            )}

          </Box>
        </Box>
        {(admin === "Admin" || permissions?.account?.isEdit) &&
          <Box sx={styles.inputBox} ml={1} mb={0.3}>
            <Select
              value={company || ""}
              onChange={(event) => { setCompany(event.target.value) }}
              name="company"
              sx={styles.hoursInput}
              displayEmpty
            >
              <MenuItem disabled value="" style={{ fontSize: 10 }}>
                Select Company
              </MenuItem>
              {companyList?.map((item, index) => (
                <MenuItem key={index} sx={styles.dropDownMenu} onClick={() => { handleCompanyDetails(item?._id, item.companyName) }}
                  value={item.companyName}>{item.companyName}</MenuItem>
              ))}

            </Select>
          </Box>
        }
      </Box>

    </Box>
  );
};

export default SubHeader;
